import { useEffect, useState } from 'react';
import { makeDefaultSim } from '../features/FloodSimSettings/config/floodSimConfig';
import { getChangedSettings } from '../utils/settings.utils';

const createSettingsDraft = (device) => ({
  node_id: device?.node_id,
  uuid: device?.uuid,
  imei: device?.IMEI,
  depthDet1: device?.device_settings?.depthDet1,
  depthDet2: device?.device_settings?.depthDet2,
  depthDet3: device?.device_settings?.depthDet3,
  depthHoldHours: device?.device_settings?.depthHoldHours,
  ffTheshold: device?.device_settings?.ffTheshold || 0,
  dropThresh: device?.device_settings?.dropThresh,
  mode: device?.device_settings?.mode,
  samp: device?.device_settings?.samp,
  dDetImgEnable: device?.device_settings?.dDetImgEnable,
  ffiImgEnable: device?.device_settings?.ffiImgEnable ?? 0,
  dRateImgEnable: device?.device_settings?.dRateImgEnable,
  hResImgEnable: device?.device_settings?.hResImgEnable,
  water_level_adj: device?.device_settings?.water_level_adj,
  externalDevice: device?.device_settings?.externalDevice,
  volConstant: device?.device_settings?.volConstant,
  calibration: device?.device_settings?.calibration,
  calType: device?.device_settings?.calType,
  resetCalibration: false,
  imgHoldEnable: device?.device_settings?.imgHoldEnable,
  imgHoldStart: device?.device_settings?.imgHoldStart,
  imgHoldEnd: device?.device_settings?.imgHoldEnd,
  imageRequest: false,
  gpsSync: false,
  ipAddress: device?.device_settings?.ipAddress,
  protocol: device?.device_settings?.protocol,
  port: device?.device_settings?.port,
  reboot: false,
  sim: device?.device_settings?.sim ?? makeDefaultSim(),
});

const useSettingsDraft = (device) => {
  const [deviceSettings, setDeviceSettings] = useState(() => createSettingsDraft(device));
  const [pendingDownstream, setPendingDownstream] = useState([]);

  useEffect(() => {
    setPendingDownstream([]);
  }, [device?.id]);

  useEffect(() => {
    setDeviceSettings((previous) => {
      const fresh = createSettingsDraft(device);
      const hasUnsavedSettings =
        Object.keys(getChangedSettings(device?.device_settings, previous)).length > 0;
      return hasUnsavedSettings && previous.node_id === fresh.node_id ? previous : fresh;
    });
    // Keep reconciliation tied to selection/settings refreshes, not unrelated readings.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [device?.id, device?.device_settings]);

  const handleInputChange = (field, value) => {
    setDeviceSettings((previous) => ({ ...previous, [field]: value }));
  };

  const stageDownstream = (downstreamId, speedMph) => {
    setPendingDownstream((previous) => [
      ...previous.filter((link) => link.id !== downstreamId),
      { id: downstreamId, speedMph },
    ]);
  };

  const unstageDownstream = (downstreamId) => {
    setPendingDownstream((previous) => previous.filter((link) => link.id !== downstreamId));
  };

  return {
    deviceSettings,
    setDeviceSettings,
    handleInputChange,
    pendingDownstream,
    setPendingDownstream,
    stageDownstream,
    unstageDownstream,
  };
};

export default useSettingsDraft;
